import * as actionTypes from "./actionTypes";
import authenticationService from "../../../api/Authentication/AuthenticationService";
export function storeUserDetails(user) {
  return (dispatch) => {
    dispatch({ type: actionTypes.STORE_USER, user });
  };
}

export function getUserByToken() {
  return (dispatch) => {
    authenticationService.getUserByToken().then((res) => {
      let userDetails = res.data;
      dispatch({ type: actionTypes.STORE_USER_DETAILS, userDetails });
    });
  };
}

export function updatePassword(password, id) {
  return (dispatch) => {
    authenticationService.updatePassword(password, id).then((res) => {
      console.log(res);
    });
  };
}

export function setAttribute(e) {
  console.log(e.name, e.value);
  return (dispatch) => {
    dispatch({
      type: actionTypes.SET_ATTRIBUTE,
      payload: { name: e.name, value: e.value },
    });
  };
}
